///<reference path="../../services/base2.service.ts"/>
import {Component, ElementRef, ViewChild} from '@angular/core'
import {HttpService} from "../../services/http.service";
import {RequestService} from "../../services/requests.service";
import {BsModalComponent} from "ng2-bs3-modal/ng2-bs3-modal";
import {Request} from "../../models/request.model";
import {AgentUtility} from "../../util/agent.utility";
import {DateUtility} from "../../util/date.utility";
import {Browser} from "selenium-webdriver";
import {BrowserUtility} from "../../util/browser.utility";
import {FileUploader} from 'ng2-file-upload';
import {AppSettings} from "../../app.settings";
import {ResponseApi} from "../../services/response/response";

const URL = AppSettings.apiUrl + "requests/upload";

@Component({
    moduleId: module.id,
    selector: 'requests',
    templateUrl: 'requests.component.html',
    styleUrls: ['requests.component.css'],
    providers: [RequestService]
})
export class RequestsComponent {
    public uploader: FileUploader = new FileUploader({autoUpload: false, url: URL});
    @ViewChild('requestModal',{static: false}) requestModal: BsModalComponent;
    @ViewChild('regioninput',{static: false}) elRegion: ElementRef;
    @ViewChild('cityinput',{static: false}) elCity: ElementRef;
    @ViewChild('streetinput',{static: false}) elStreet: ElementRef;
    @ViewChild('houseinput',{static: false}) elHouse: ElementRef;
    @ViewChild('flatinput',{static: false}) elFlat: ElementRef;
    @ViewChild('zip_code_input',{static: false}) elCode: ElementRef;
    request: Request = new Request();
    types: any[] = [];
    subtypes: any[] = [];
    typeId: number = 0;
    subtypeId: number = 0;
    nameTypes: string[] = [];
    showLoadScreen: boolean = false;
    requests: any[];
    agent = AgentUtility.getUser();
    step: number = 1;
    countSteps: number = 3;
    datepickerOpts: any = {
        autoclose: true,
        assumeNearbyYear: true,
        format: 'yyyy',
        placeholder: " ",
        icon: 'client-full__calendar',
        language: 'ru',
        maxViewMode: 'years',
        minViewMode: 'years',
        startDate: new Date('1'),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1)
    };

    datepickerOpts2: any = {
        autoclose: true,
        todayHighlight: true,
        assumeNearbyYear: true,
        format: 'dd.mm.yyyy',
        placeholder: " ",
        icon: 'client-full__calendar',
        language: 'ru',
        defaultViewDate: 'today'
    };
    validate: any = {
        secondname: null,
        email: null,
        firstname: null,
        period: null,
        count: null,
        region: null,
        street: null,
        city: null,
        house: null,
        IssuedBy: null,
        WhenIssued: null,
        SerialPassport: null,
        NumberPassport: null,
        NumberINN: null,
        birthday: null,
        gender: -1,
        zip_code: null
    };

    constructor(private httpService: HttpService, private requestService: RequestService) {
        this.requestService.onStart = () => this.showLoadScreen = true;
        this.requestService.onEnd = () => this.showLoadScreen = false;
        this.nameTypes[1] = "Бухгалтерия";
        this.nameTypes[2] = "2-НДФЛ";
        this.nameTypes[3] = "Отдел кадров";
        this.nameTypes[4] = "Справка 182н";
        this.uploader.onAfterAddingAll = (file) => {
            this.uploader.uploadAll()
        };
        this.uploader.onCompleteItem = (file, response) => {
            this.request.filesNames.push(response);
        };
    }

    setModel() {
        if (this.elRegion != undefined && this.elCity != undefined && this.elStreet != undefined && this.elHouse != undefined) {
            this.request.Region = this.elRegion.nativeElement.value;
            this.request.City = this.elCity.nativeElement.value;
            this.request.Street = this.elStreet.nativeElement.value;
            this.request.House = this.elHouse.nativeElement.value;
            this.request.Flat = this.elFlat.nativeElement.value;
            this.request.zip_code = this.elCode.nativeElement.value;
            // this.requestService.getKladr(this.request.Region + ", " + this.request.City + ", " + this.request.Street + ", " + this.request.House).subscribe((data) => {
            //     this.request.zip_code
            // });
        }
    }

    bytesToSize(bytes: number): string {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        var log: number = Math.log(bytes);
        var log2: number = Math.log(1024);
        var i = Math.floor(log / log2);
        return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
    };

    openModal() {
        this.request.IsAuth = true;
        let agent = AgentUtility.getUser();
        this.request.FirstName = agent.FirstName;
        this.request.SecondName = agent.Name;
        this.request.MiddleName = agent.MiddleName;
        this.request.Email = agent.Email;
        this.request.userInfo = agent;
        //this.request.Period = DateUtility.getPeriod();
        this.requestModal.open();
    }

    setStep(step: number) {
        if (step < 1 || step > this.countSteps) {
            return;
        }
        if (this.step == 1) {
            if (this.request.FirstName == "") {
                this.validate.firstname = false;
            } else {
                this.validate.firstname = true;
            }
            if (this.request.gender == '-1') {
                this.validate.gender = false;
            } else {
                this.validate.gender = true;
            }

            if (this.request.Email == "" || this.request.Email == null) {
                this.validate.email = false;
            } else {
                this.validate.email = true;
            }

            if (this.request.SecondName == "") {
                this.validate.secondname = false;
            } else {
                this.validate.secondname = true;
            }

            if (this.request.Period == undefined) {
                this.validate.period = false;
                var div = document.querySelector('#period > div > div');
                div.classList.add("error");
            } else {
                this.validate.period = true;
                var div = document.querySelector('#period > div > div');
                div.classList.remove("error");
            }
            if (this.request.Birthday == undefined) {
                this.validate.birthday = false;
                var div = document.querySelector('#birthday > div > div');
                div.classList.add("error");
            } else {
                this.validate.birthday = true;
                var div = document.querySelector('#birthday > div > div');
                div.classList.remove("error");
            }

            if (isNaN(+this.request.Count) || +this.request.Count < 1) {
                this.validate.count = false;
            } else {
                this.validate.count = true;
            }

            if (!this.IsFinished1()) {
                return;
            }
        }

        if (this.step == 2 && step != 1) {
            if (this.request.Region == "") {
                this.validate.region = false;
            } else {
                this.validate.region = true;
            }

            if (this.request.City == "") {
                this.validate.city = false;
            } else {
                this.validate.city = true;
            }

            if (this.request.Street == "") {
                this.validate.street = false;
            } else {
                this.validate.street = true;
            }

            if (this.request.House == "") {
                this.validate.house = false;
            } else {
                this.validate.house = true;
            }

            if (!this.IsFinished2()) {
                return;
            }
        }

        if (this.step == 3 && step != 2 && step != 1) {

        }
        this.step = step;

        if (step == 2) {
            setTimeout(() => {
                this.fixdaData();
            }, 1000);

        }
    }

    getNameSub() {
        var self = this;
        var search = this.subtypes.filter(s => {
            return s.Id == self.subtypeId;
        });
        if (search.length > 0)
            return search[0].Name;
        else
            return "";
    }

    sendRequest() {
        if (this.showLoadScreen) {
            return;
        }

        if (this.step == 3) {
            if (!this.IsFinished1() || !this.IsFinished2()) {
                return;
            }
            // Чекаем паспорт
            if (this.request.TypeDocument == 1) {
                if (this.request.IssuedBy == "") {
                    this.validate.IssuedBy = false;
                } else {
                    this.validate.IssuedBy = true;
                }

                if (this.request.WhenIssued == undefined) {
                    var div = document.querySelector('#dateGiven > div > div');
                    div.classList.add("error");
                    this.validate.WhenIssued = false;
                } else {
                    this.validate.WhenIssued = true;
                    var div = document.querySelector('#dateGiven > div > div');
                    div.classList.remove("error");
                }

                if (this.request.SerialPassport == "" || this.request.SerialPassport.length < 4 || isNaN(+this.request.SerialPassport)) {
                    this.validate.SerialPassport = false;
                } else {
                    this.validate.SerialPassport = true;
                }

                if (this.request.NumberPassport == "" || this.request.NumberPassport.length < 6 || isNaN(+this.request.NumberPassport)) {
                    this.validate.NumberPassport = false;
                } else {
                    this.validate.NumberPassport = true;
                }

            }

            if (this.request.TypeDocument == 2) {
                if (this.request.NumberINN == "" || isNaN(+this.request.NumberINN)) {
                    this.validate.NumberINN = false;
                } else {
                    this.validate.NumberINN = true;
                }
            }

            if (!this.IsFinished3()) {
                return;
            }

            this.showLoadScreen = true;
            if (this.uploader.isUploading) {
                this.uploader.onCompleteAll = this.log.bind(this);
            } else {
                this.log();
            }
        }
    }

    fixdaData() {
        window['eval']('test(this, test2);');
        window['eval'](` 
            $region = $("#region"),
            $city   = $("#city"),
            $street = $("#street"),
            $house  = $("#house");
            alert
        // регион и район
        $region.suggestions({
            token: token,
            type: type,
            hint: false,
            bounds: "region-area"
        });

        // город и населенный пункт
        $city.suggestions({
            token: token,
            type: type,
            hint: false,
            bounds: "city-settlement",
            constraints: $region,
            formatSelected: formatCity
        });

        // улица
        $street.suggestions({
            token: token,
            type: type,
            hint: false,
            bounds: "street",
            constraints: $city
        });

        // дом
        $house.suggestions({
            token: token,
            type: type,
            hint: false,
            bounds: "house",
            constraints: $street,
            onSelect: showSelected
        });
        function showSelected(suggestion) {
          var address = suggestion.data;
          showPostalCode(address);
          
        }
        function showPostalCode(address) {
          $("#zip_code").val(address.postal_code);
        }

        
`);
    };

    IsFinished1(): boolean {
        return this.validate.secondname && this.validate.firstname && this.validate.count && this.validate.period && this.validate.email && this.validate.gender;
    }

    IsFinished2(): boolean {
        return this.validate.region && this.validate.city && this.validate.street && this.validate.house;
    }

    IsFinished3(): boolean {
        if (this.request.TypeDocument == 1) {
            return this.validate.IssuedBy && this.validate.WhenIssued && this.validate.SerialPassport && this.validate.NumberPassport;
        }
        if (this.request.TypeDocument == 2) {
            return this.validate.NumberINN;
        }
    }

    log() {
        this.request.RequestTypeId = this.subtypeId != 0 ? this.subtypeId : 0;
        if (this.uploader.isUploading) {
            alert("Дождитесь загрузки файлов");
            return false;
        }
        this.uploader.onCompleteAll = null;

        this.requestService.getKladr(this.request.Region + ", " + this.request.City + ", " + this.request.Street + ", " + this.request.House).subscribe((data) => {
            data = data.suggestions[0];
            if (data.data.kladr_id != null) {
                this.request.kladr = data.data.kladr_id;
                if (this.checkNull()) {
                    alert("Заполните все поля формы");
                    this.showLoadScreen = false;
                } else {
                    this.requestService.addTypes(this.request).subscribe((data: ResponseApi) => {
                        if (data.data['status'] == "OK") {
                            this.request = new Request();
                            this.uploader.queue = [];
                            this.step = 1;
                            this.typeId = 0;
                            this.subtypeId = 0;
                            this.subtypes = [];
                            this.validate = {
                                secondname: null,
                                email: null,
                                firstname: null,
                                period: null,
                                count: null,
                                region: null,
                                street: null,
                                city: null,
                                house: null,
                                IssuedBy: null,
                                WhenIssued: null,
                                SerialPassport: null,
                                NumberPassport: null,
                                NumberINN: null,
                                birthday: null,
                                gender: -1
                            };
                            this.getAll();
                            this.requestModal.close();
                            this.showLoadScreen = false;
                        }
                    });
                }
            } else {
            }
        });
    }

    getCountRequests(): boolean {
        return this.requests != undefined && this.requests.length > 0;
    }

    ngOnInit() {
        var that = this;
        if (BrowserUtility.detectIE()) {
            setInterval(function () {
                that.setModel();
            }, 1000);
        }

        //this.requestModal.open();
        this.requestService.getTypes().subscribe((data: ResponseApi) => {
            this.types = data.data;
        });
        this.getAll();
    }

    getAll() {
        this.requestService.getAllByAgent(this.agent.Id).subscribe((data: ResponseApi) => {
            this.requests = data.data;
        })
    }

    loadSub() {
        this.subtypeId = 0;
        this.requestService.getSubTypes(this.typeId).subscribe((data: ResponseApi) => {
            data.data = data.data.filter(function (sub) {
                //debugger;
                return sub.AnonymousUse == null || sub.AnonymousUse == true;
            });

            this.subtypes = data.data;
        });
    }

    change() {

    }

    close() {
        this.requestModal.close();
    }

    parseDate(date) {
        return DateUtility.parseDateWithLeadZero(new Date(date));
    }

    checkNull(): boolean {
        //debugger;
        // let self = this;
        // return Object.keys(this.request).some(function (objectKey) {
        //     var value = self.request[objectKey];
        //     return objectKey != "kladr" && objectKey != "IsAuth" && (value == "" || value == 0);
        // });
        if (
            this.request.FirstName == "" ||
            this.request.SecondName == "" ||
            this.request.Region == "" ||
            this.request.City == "" ||
            this.request.Street == "" ||
            this.request.House == "") {
            return true;
        }

        if (this.request.Count < 1) {
            return true;
        }
        return false;
    }

    removeFile(item) {
        this.request.filesNames = this.request.filesNames.filter((file) => {
            return file.indexOf(item.file.name) < 0;
        });
        
        item.remove();
    }
}